@if (loading) {
  <mat-spinner [diameter]="30" />
} @else {
  @if (expired) {
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        <div>
          The reset password link you've clicked is no longer valid. For
          security reasons, these links expire after a certain period. Please
          request a <a href="/forgot-password">new password reset link</a> to
          continue.
        </div>
        <p class="mt-3"><strong>Need help?</strong></p>
        <p>
          Contact support at <strong><a href="mailto:{{ supportEmailAddress }}">{{ supportEmailAddress }}</a></strong>
          or call us at <strong><a href="tel:1-781-214-3424" class="text-nowrap">1-781-214-3424</a></strong>.
        </p>
      </div>
    </div>
  } @else {
    <div class="row">
      <div class="col-lg-8 offset-lg-4">
        @if (mode === createPasswordModes.newUser) {
          <p>Hi {{ firstName }}, please create a password.</p>
        }
        @if (mode === createPasswordModes.passwordReset) {
          <p>Hi {{ firstName }}, please create a new password.</p>
        }
        @if (mode === createPasswordModes.forcePasswordChange) {
          <p>
            Hi {{ firstName }}, it’s been 90 days since you set your password. It’s time to choose a new one.
          </p>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 offset-lg-4">
        <form (ngSubmit)="onSubmit(createPasswordForm)" #createPasswordForm="ngForm">
          <div class="mb-3">
            <label for="password">Password</label>
            <input
              id="password"
              name="password"
              class="form-control"
              type="password"
              [(ngModel)]="formModel.password"
              [ngClass]="invalidCss('password', createPasswordForm)"
              required
              placeholder="Password"
            />
            <div class="invalid-feedback">Required.</div>
          </div>
          <div class="mb-3">
            <label for="password">Re-enter Password</label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              class="form-control"
              type="password"
              [(ngModel)]="formModel.confirmPassword"
              [ngClass]="invalidCss('confirmPassword', createPasswordForm)"
              required
              placeholder="Re-enter password"
            />
            <div class="invalid-feedback">Required.</div>
          </div>
          @if (!hideMfaFields) {
            <div class="mb-3">
              <label><strong>Phone Number for Multi-factor Authentication</strong></label>
              <input
                id="phone"
                name="phone"
                class="form-control"
                [disabled]="phoneFieldDisabled"
                [(ngModel)]="formModel.phone"
                [ngClass]="invalidCss('phone', createPasswordForm)"
                [pattern]="phonePattern"
                required
                #phoneModel="ngModel"
              />
              <div class="invalid-feedback">Required.</div>
              @if (phoneModel.errors?.pattern) {
                <div class="invalid-feedback">Phone is invalid.</div>
              }
              <div>This number must be capable of receiving text messages.</div>
            </div>
            <div class="mb-3">
              <div class="form-check">
                <input
                  id="smsOptIn"
                  name="smsOptIn"
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="formModel.smsOptIn"
                  [ngClass]="invalidCss('smsOptIn', createPasswordForm)"
                />
                <label class="form-check-label" for="smsOptIn">
                  By checking this box, you agree to receive text messages from
                  NuvemRX for multi-factor authentication (MFA) purposes only. No
                  marketing messages will be sent. Standard message and data
                  rates may apply.
                </label>
              </div>
            </div>
          }
          <button
            type="submit"
            class="btn btn-primary w-100"
            [disabled]="createPasswordForm.invalid || submitting || (!hideMfaFields && !formModel.smsOptIn)"
          >
            Submit
          </button>
          @if (resetPasswordStatus === resetPasswordStatuses.ExpiredCode) {
            <p class="text-danger my-2">
              Hi user {{ firstName }}, it looks like your registration link has
              expired. Please contact support {{ supportEmailAddress }} or by
              calling 1-781-214-3424.
            </p>
          }
          @if (resetPasswordStatus === resetPasswordStatuses.PasswordViolatesPolicy) {
            <p class="text-danger my-2">
              The password entered does not meet the minimum requirements of
              ten characters or more, must contain one number and must contain
              at least one uppercase letter.
            </p>
          }
          @if (resetPasswordStatus === resetPasswordStatuses.PasswordsDoNotMatch) {
            <p class="text-danger my-2">
              The passwords entered do not match.
            </p>
          }
          @if (resetPasswordStatus === resetPasswordStatuses.UnexpectedFailure) {
            <p class="text-danger my-2">
              An unexpected error has occurred. Please try again or contact support.
            </p>
          }
          @if (resetPasswordStatus === resetPasswordStatuses.PasswordAlreadyUsed) {
            <p class="text-danger my-2">
              Your new password can’t be any of your 10 previous passwords. Please enter a new password.
            </p>
          }
        </form>
        <p class="mt-3 text-center">
          <strong>Need help?</strong> <br />
          Contact support at <strong><a href="mailto:{{ supportEmailAddress }}">{{ supportEmailAddress }}</a></strong> <br />
          or call us at <strong><a href="tel:1-781-214-3424">1-781-214-3424</a></strong>.
        </p>
      </div>
      <div class="col-lg-4">
        <div class="text-muted pt-3">
          Your password must meet the following requirements:
          <ul class="list-unstyled">
            <li>- Can’t be any of your 10 previous passwords</li>
            <li>- 10 characters or more</li>
            <li>- Contains at least one number</li>
            <li>- Contains at least one uppercase letter</li>
          </ul>
        </div>
      </div>
    </div>
  }
}
